var map = {
	"./areas/data-sources/components/DataSourceDataGridWidget/widgetDescription": "./src/app/areas/data-sources/components/DataSourceDataGridWidget/widgetDescription.ts",
	"./areas/data-sources/components/DataSourceSingleGraphWidget/widgetDescription": "./src/app/areas/data-sources/components/DataSourceSingleGraphWidget/widgetDescription.ts",
	"./areas/incidents/widgets/IncidentsGridWidget/widgetDescription": "./src/app/areas/incidents/widgets/IncidentsGridWidget/widgetDescription.tsx",
	"./areas/metrics/widgets/Compass/widgetDescription": "./src/app/areas/metrics/widgets/Compass/widgetDescription.tsx",
	"./controls/designer/features/widgets/export/widgetDescription": "./src/app/controls/designer/features/widgets/export/widgetDescription.tsx",
	"./controls/designer/features/widgets/textWidget/widgetDescription": "./src/app/controls/designer/features/widgets/textWidget/widgetDescription.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app sync recursive widgetDescription$";